import React, { useMemo } from 'react';

import {
	useClassNames,
} from '@common';

import {
	Avatar, Popover,
} from '@components'
import { authService } from '@services';
import './User.scss';

interface UserProps extends React.HTMLAttributes<HTMLDivElement> {
	avatarSrc?: string,
	name: string,
}

function User(props: UserProps): JSX.Element {
	const {
		name,
		avatarSrc,
		className,
		...otherProps
	} = props;

	const classes = useClassNames('user', className);
	
	const logout = () => {
		authService.logout();
	};

	const optionsView = useMemo((): JSX.Element => {
		return (
			<div
				onClick={logout}
				className='popover-select__option'
				key='logout_item'
			>
				Выйти
			</div>
		);
	}, []);

	return (
		<Popover content={optionsView} className="userPopover">
		<div className={classes} {...otherProps}>
			<Avatar
				avatarSrc={avatarSrc}
				name={name}
				className="user__avatar"
			/>
			<div className="user__info">
				{name}
			</div>
		</div>
		</Popover>
	);
}

export {User};